import { usePublicEventOptions } from "../../common/public-options";
import type { DropdownOption } from "../types/event.types";

interface UseEventOptionsReturn {
  neighborhoodOptions: DropdownOption[];
  fetchNeighborhoodOptions: () => Promise<void>;
  categoryOptions: DropdownOption[];
  fetchCategoryOptions: () => Promise<void>;
  subCategoryOptions: DropdownOption[];
  fetchSubCategoryOptions: () => Promise<void>;
}

export const useEventOptions = (organizationId?: string): UseEventOptionsReturn => {
  const {
    neighborhoodOptions,
    fetchNeighborhoodOptions,
    categoryOptions,
    fetchCategoryOptions,
    interestOptions: subCategoryOptions,
    fetchInterestOptions: fetchSubCategoryOptions,
  } = usePublicEventOptions(organizationId);

  return {
    neighborhoodOptions,
    fetchNeighborhoodOptions,
    categoryOptions,
    fetchCategoryOptions,
    subCategoryOptions,
    fetchSubCategoryOptions,
  };
};
